module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-18MARZO-25-e02757e79df90eb28c0bf17403bf5e18.png";